module.exports = __webpack_public_path__ + "media/images/avatar/6-f8ab8d7d7fbdee1b354c5d5c61a4e1a9.svg";